import { render, staticRenderFns } from "./gb-whatsapp-ios.vue?vue&type=template&id=5a6b7f78&scoped=true"
import script from "./gb-whatsapp-ios.vue?vue&type=script&lang=js"
export * from "./gb-whatsapp-ios.vue?vue&type=script&lang=js"
import style0 from "./gb-whatsapp-ios.vue?vue&type=style&index=0&id=5a6b7f78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6b7f78",
  null
  
)

export default component.exports